import { AddressAPI } from "../utils/address_api"
import axios from "axios"

export function GooglePlaceAPI() {
  function init(addressField) {
    let autocomplete = new google.maps.places.Autocomplete(addressField, {
      componentRestrictions: { country: ["us"] },
      types: ["address"],
       bounds: {west: -124.7844079, east: -66.9513812 , south: 24.7433195 , north: 49.3457868 },
      strictBounds: true,
      fields: ["address_components", "geometry", "formatted_address", "place_id"],
    });

    return autocomplete;
  }

function getAddressInformation(autocomplete) {
  const place = autocomplete.getPlace();
  if (!place.geometry) return {};

  let street_number = "", address = "", postcode = "", city = "", state = "", country = "";

  const typeMap = {
    street_number: val => street_number = val,
    route: val => address = `${street_number} ${val}`.trim(),
    postal_code: val => postcode = `${val}${postcode}`,
    postal_code_suffix: val => postcode = `${postcode}-${val}`,
    locality: val => city = val,
    administrative_area_level_1: val => state = val,
    country: val => country = val
  };

  const cityFallbacks = ["administrative_area_level_2", "sublocality", "neighborhood"];

  for (const component of place.address_components) {
    for (const type of component.types) {
      if (typeMap[type]) {
        typeMap[type](type === "country" ? component.short_name : component.long_name);
      } else if (!city && cityFallbacks.includes(type)) {
        city = component.long_name;
      }
    }
  }

  return {
    street_number,
    address,
    city,
    zipcode: postcode,
    state,
    place: `${address}, ${city}, ${state} ${postcode}, ${country}`,
    longitude: place.geometry.location.lng(),
    latitude: place.geometry.location.lat()
  };
}

  return {
    init,
    getAddressInformation,
  }
}